import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DOMPurify from 'dompurify';
import withInit from 'WithInit';
import MessageHandler from 'message-handler';

class Alert extends React.PureComponent {
  render() {
    const alertType = this.props.type.toLowerCase();
    const className = classnames(
      'alert',
      {
        'alert-danger': alertType === 'error',
        [`alert-${alertType}`]: alertType !== 'error',
      },
    );

    const label = alertType.charAt(0).toUpperCase() + alertType.slice(1).toLowerCase();
    const message = MessageHandler.getErrorMessage(this.props.code, this.props.email);
    return (
      <div className={className}>
        <strong>{label}!</strong>
        &nbsp;
        <span dangerouslySetInnerHTML={{ __html: `${DOMPurify.sanitize(message)}` }} />
      </div>
    );
  }
}

Alert.defaultProps = {
  email: '',
};

Alert.propTypes = {
  type: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  email: PropTypes.string,
};

export default withInit(Alert);



// WEBPACK FOOTER //
// ./src-react/Alert/index.jsx